import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {parseValidationErrors} from 'services/api/utils/parse-error';
import {useDettachContactMutation} from 'store/directory/endpoints/dettach-contact';
import {selectActiveModalParams} from 'store/ui/selectors';
import {uiActions} from 'store/ui/ui-slice';

const __DEV__ = process.env.NODE_ENV === 'development';

export const useDestroyDirectoryForm = (onDismiss: () => void) => {
  const [update, {isLoading, error, isSuccess}] = useDettachContactMutation();

  const serverError = parseValidationErrors(error);

  const modalParams = useSelector(selectActiveModalParams);

  const {directory, contact, message} = modalParams;
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const result = await update({
      contact: contact,
      id: directory.id,
    });
    if ('data' in result) {
      dispatch(uiActions.dismissModal());
      toast.success(result.data.message);
    }
  };

  return {
    message,
    isLoading,
    validationErrors: serverError.errors,
    errorMessage: serverError.message,
    submit: handleSubmit,
  };
};

type CopyParams = {};
